import { useState } from "react";
import { GlobalContext } from "./globalContext";

export const GlobalState = (props) => {

    const [loader, setLoader] = useState(false);
    const [loggedIn, setLoggedIn] = useState(sessionStorage.getItem('token') ? true : false);
    const [token, setToken] = useState(sessionStorage.getItem('token'));
    const [comanyName, setCompanyName] = useState(sessionStorage.getItem('company_name'));

    const value = {
        loader, setLoader,
        loggedIn, setLoggedIn,
        token, setToken,
        comanyName, setCompanyName
    }

    return (
        <GlobalContext.Provider value={value}>
            {props.children}
        </GlobalContext.Provider>
    )

}